export default "__VITE_ASSET__CVVipkT1__"